import { useEffect } from "react";
import useReveal from "../hooks/useReveal";
import { BuildDayNav } from "../components/buildday/Nav";
import { BuildDayHero } from "../components/buildday/Hero";
import { WhatIsBuildDay } from "../components/buildday/WhatIsBuildDay";
import { Timeline } from "../components/buildday/Timeline";
import { LeaveWith } from "../components/buildday/LeaveWith";
import { BuildDayWhoFor } from "../components/buildday/WhoFor";
import { BuildDayGallery } from "../components/buildday/Gallery";
import { BuildDayApplication } from "../components/buildday/Application";
import { BuildDayFinalCTA } from "../components/buildday/FinalCTA";
import { BuildDayFooter } from "../components/buildday/Footer";

export default function BuildDay() {
  const ref = useReveal();

  useEffect(() => {
    const prevTitle = document.title;
    document.title = "The Builders Sprint · Jordan Young";
    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <div
      ref={ref}
      data-testid="buildday-page"
      className="bg-[#0A0A0C] text-white"
    >
      <BuildDayNav />
      <main>
        <BuildDayHero />
        <WhatIsBuildDay />
        <Timeline />
        <LeaveWith />
        <BuildDayWhoFor />
        <BuildDayGallery />
        <BuildDayApplication />
        <BuildDayFinalCTA />
      </main>
      <BuildDayFooter />
    </div>
  );
}
